import Api from '@/api/Api'
import store from '../store'

export default {
  async getAll (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('payments', { params }))
  },
  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('payment?pe_id=' + data.pe_id))
  },
  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('payment', data, options))
  },
  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('payment', data, options))
  },
  async updateStatus (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('payment/status', data, options))
  },
  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('payment', { data: data }, options))
  },
  async getLatestCode (data) {
    return store.dispatch('checkResponseApi', await Api().get('payment/latest_code'))
  },
  async getMasterData () {
    return store.dispatch('checkResponseApi', await Api().get('payment/methods'))
  },
  async updatePaymentMethod (type, data) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`payment/methods/${type}`, data, options))
  },
  async getCharge (chargeId) {
    return store.dispatch('checkResponseApi', await Api().get(`payment/charge/${chargeId}`))
  },
  async getTransactionBy (chargeId) {
    return store.dispatch('checkResponseApi', await Api().get(`payment/charge/${chargeId}/transaction`))
  },
  async chargeInvoice (data) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('payment/charge/invoice', data, options))
  },
  async chargePackage (data) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('payment/charge/package', data, options))
  },
}



// WEBPACK FOOTER //
// ./src/api/PaymentService.js